import Vue from 'vue'
import Router from 'vue-router'
import BasicPlayer from "./components/BasicPlayer";
import VueCookies from "vue-cookies";
import {logIn} from "ionicons/icons";
import * as alert from "./utils/alert";


Vue.use(Router);

let router = new Router({
    mode: 'history',
    // base: process.env.BASE_URL,
    routes: [
        {
            // 테스트화면
            path: '/home1',
            name: 'home1',
            component: BasicPlayer,
            props:true,
            meta: {
                auth: true
            }
        },
        {
            // 홈화면 - 인트로
            path: '/Intro',
            component: () => import('./views/main/Intro.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 홈화면 - 메인 ----낡은판본
            path: '/',
            name: 'main',
            component: () => import('./views/main/Main.vue'),
            props: (route) => ({ query: route.query.site }),
            meta: {
                auth: false
            }
        },
        {
            path: '/home',
            name: 'home',
            component: () => import('./views/home/Home.vue'),
            meta: {
                auth: false
            }
        },
        {
            // 홈화면 - 추천 강의
            path: '/Recommended',
            component: () => import('./views/main/RecommendedCourse.vue'),
            meta: {
                auth: false
            }
        },
        {
            // 듣는노트
            path: '/ListeningNote',
            component: () => import('./views/main/ListeningNoteDetail.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 홈화면 - 이용약관, 개인정보 처리방침
            path: '/AgreeInfo/:div',
            component: () => import('./views/main/AgreeInfo.vue'),
            props: true,
            meta: {
                auth: false
            }
        },
        {
            // 사용자Login
            path: '/login',
            name: 'login',
            component: () => import('./views/member/Login.vue'),
            meta: {
                auth: false
            }
        },
        {
            // Find ID
            path: '/member/find/id',
            component: () => import('./views/member/FindId.vue'),
            meta:{
                auth:false,
            }
        },

        {
            // Find password
            path: '/member/find/password',
            component: () => import('./views/member/FindPassword.vue'),
            meta:{
                auth:false,
            }
        },
        {
            path: '/member/find/password/step1/:member_id',
            component: () => import('./views/member/FindPasswordStep1.vue'),
            meta:{
                auth:false,
            }
        },
        {
            path: '/member/find/password/step2/:member_no',
            component: () => import('./views/member/FindPasswordStep2.vue'),
            meta:{
                auth:false,
            }
        },

        {
            // 회원가입 - 회원유형
            path: '/member/join/step1',
            component: () => import('./views/member/JoinStep1.vue'),
            meta:{
                auth:false,
            }
        },
        {
            // 회원가입 - 약관동의
            path: '/member/join/step2',
            component: () => import('./views/member/JoinStep2.vue'),
            meta:{
                auth:false,
            }
        },
        {
            // 회원가입 - 회원정보 입력
            path: '/member/join/member/:marketing_agree_yn',
            component: () => import('./views/member/JoinMember.vue'),
            meta:{
                auth:false,
            }
        },
        {
            // 회원가입 - 학생회원
            path: '/member/join/student/:marketing_agree_yn',
            component: () => import('./views/member/JoinStudent.vue'),
            meta:{
                auth:false,
            }
        },
        {
            // 회원가입 - 학부모회원
            path: '/member/join/parent/:marketing_agree_yn',
            component: () => import('./views/member/JoinParent.vue'),
            meta:{
                auth:false,
            }
        },
        {
            // 회원가입 - 가입완료
            path: '/member/join/complete',
            name: 'JoinComplete',
            component: () => import('./views/member/JoinComplete.vue'),
            props: true,
            meta:{
                auth:false,
            }
        },
        {
            // 마이페지 - 비밀번호 확인
            path: '/mypage/confirm/password',
            component: () => import('./views/mypage/ConfirmPassword.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - 메인
            path: '/mypage/main',
            component: () => import('./views/mypage/Main.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - 이용권
            path: '/mypage/ticket',
            component: () => import('./views/mypage/Ticket.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - 구독상세 정보 (iOS 인 경우에만)
            path: '/mypage/payment/detail',
            name: 'PaymentDetail',
            component: () => import('./views/mypage/PaymentDetail.vue'),
            props: true,
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - 결제
            path: '/mypage/payment',
            name: 'MyPagePayment',
            component: () => import('./views/mypage/Payment.vue'),
            props: true,
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - 자동결제승인
            // 자동결제 인증 후 승인요청을 위한 페지
            path: '/mypage/payment/approval/:order_no',
            component: () => import('./views/mypage/PaymentApproval.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - 결제완료
            path: '/mypage/payment/complete/:order_no',
            component: () => import('./views/mypage/PaymentComplete.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - 결제실패
            path: '/mypage/payment/fail/:order_no',
            component: () => import('./views/mypage/PaymentFail.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - 이용권 해지 선택
            path: '/mypage/ticket/cancel',
            name: 'CancelTicket',
            component: () => import('./views/mypage/CancelTicket.vue'),
            props: true,
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - 이용권 해지 신청
            path: '/mypage/ticket/cancel/complete',
            name: 'CancelTicketComplete',
            component: () => import('./views/mypage/CancelTicketComplete.vue'),
            props: true,
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - 쿠폰
            path: '/mypage/coupon',
            component: () => import('./views/mypage/Coupon.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - 쿠폰 등록
            path: '/mypage/coupon/register',
            component: () => import('./views/mypage/RegisterCoupon.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - 내 정보
            path: '/mypage/myinfo',
            component: () => import('./views/mypage/MyInfo.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - 개인정보 변경
            path: '/mypage/myinfo/modify',
            name: 'ModifyMyInfo',
            component: () => import('./views/mypage/ModifyMyInfo.vue'),
            props: true,
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - Review 게시판
            path: '/mypage/board',
            component: () => import('./views/mypage/Board.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - Review 게시판 보기
            path: '/mypage/board/view/:communication_no',
            component: () => import('./views/mypage/ViewBoard.vue'),
            props: true,
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - Review 게시판 글쓰기
            path: '/mypage/board/write',
            component: () => import('./views/mypage/WriteBoard.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - 고객센터
            path: '/mypage/cs',
            component: () => import('./views/mypage/CustomerService.vue'),
            meta: {
                auth: false
            }
        },
        {
            // 마이페지 - 1:1 문의하기
            path: '/mypage/cs/qna',
            component: () => import('./views/mypage/WriteQna.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - 1:1 문의하기 답변
            path: '/mypage/cs/qna/view/:question_no',
            component: () => import('./views/mypage/ViewQna.vue'),
            props: true,
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - 설정
            path: '/mypage/setting',
            component: () => import('./views/mypage/Setting.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - 설정 - Sleep Time
            path: '/mypage/setting/sleep',
            component: () => import('./views/mypage/SetSleepTime.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - 포인트 정보
            path: '/mypage/point',
            component: () => import('./views/mypage/Point.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - nugu 동의 정
            path: '/mypage/nugu',
            component: () => import('./views/mypage/nugu.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 마이페지 - 회원 탈퇴
            path: '/mypage/withdraw',
            component: () => import('./views/mypage/Withdraw.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 둘러보기
            path: '/preview/main',
            component: () => import('./views/preview/Main.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 둘러보기 - 교과강의
            path: '/preview/lecture/subject/:subject',
            component: () => import('./views/preview/SubjectLecture.vue'),
            props: true,
            meta: {
                auth: false
            }
        },
        {
            // 둘러보기 - 기획특강
            path: '/preview/lecture/plan/:subject',
            component: () => import('./views/preview/PlanLecture.vue'),
            props: true,
            meta: {
                auth: false
            }
        },
        {
            // 둘러보기 - 강좌소개
            path: '/preview/lecture/info/:lecture_no',
            component: () => import('./views/preview/LectureInfo.vue'),
            props: true,
            meta: {
                auth: false
            }
        },
        {
            // 둘러보기 - 선생님
            path: '/preview/teacher',
            component: () => import('./views/preview/Teacher.vue'),
            meta: {
                auth: false
            }
        },
        {
            // 둘러보기 - 선생님소개
            path: '/preview/teacher/info/:user_no',
            component: () => import('./views/preview/TeacherInfo.vue'),
            props: true,
            meta: {
                auth: true
            }
        },
        {
            // 둘러보기 - 내가 만든 교과서
            path: '/preview/lecture/myself',
            component: () => import('./views/preview/MyLecture.vue'),
            meta: {
                auth: false
            }
        },
        {
            // 둘러보기 - 참여하기
            path: '/preview/participant',
            component: () => import('./views/preview/Participant.vue'),
            meta: {
                auth: false
            }
        },
        {
            // 알림 - 메인(이전판본)
            path: '/notice',
            component: () => import('./views/notice/Main.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 알림 - 메인(새판본)
            path: '/notice/notice',
            component: () => import('./views/notice/Notice.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 알림 - 상세
            path: '/notice/detail/:notice_no',
            component: () => import('./views/notice/Detail.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 알림 - 상세
            path: '/useful',
            component: () => import('./views/useful/Index.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 알림 - 상세
            path: '/useful/detail/:usefulId',
            component: () => import('./views/useful/Detail.vue'),
            props:true,
            meta: {
                auth: true
            }
        },
        {
            path: '/purchase',
            component: () => import('./views/purchase/Main.vue'),
            children: [
                {
                    // 상품상세 - Buy Reword Product detail
                    path: 'detail',
                    component: () => import('./views/purchase/Detail.vue')
                },
                {
                    // 상품구매목록 - Buy Reword Product
                    path: 'reward_list',
                    component: () => import('./views/purchase/BuyRewardProductList.vue')
                },
                {
                    // 구매목록 - Buy List
                    path: 'buy_list',
                    component: () => import('./views/purchase/BuyList.vue')
                },
            ],
            meta: {
                auth: true
            }
        },
        {
            // 검색
            path: '/search',
            component: () => import('./views/search/Main.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 검색
            path: '/searchbk',
            component: () => import('./views/search/Mainbykeword.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 내교과서 - 메인
            path: '/mytextbook/main',
            component: () => import('./views/mytextbook/Main.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 내교과서 - 최근에 들은 강의
            path: '/mytextbook/course/listen',
            component: () => import('./views/mytextbook/ListenCourse.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 내교과서 - my playlist
            path: '/mytextbook/playlist',
            component: () => import('./views/mytextbook/MyPlaylist.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 내교과서 - my playlist 보기
            path: '/mytextbook/playlist/info/:playlist_no',
            component: () => import('./views/mytextbook/MyPlaylistInfo.vue'),
            props: true,
            meta: {
                auth: true
            }
        },
        {
            // 내교과서 - 내가 담은 강의
            path: '/mytextbook/course/put',
            component: () => import('./views/mytextbook/PutCourse.vue'),
            meta: {
                auth: true
            }
        },
        // {
        //     // 내교과서 - 내가 다운로드한 강의
        //     path: '/mytextbook/course/download',
        //     component: () => import('./views/mytextbook/DownloadCourse.vue')
        // },
        {
            // 내교과서 - 내가 좋아하는 강의
            path: '/mytextbook/course/interest',
            component: () => import('./views/mytextbook/InterestCourse.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 내교과서 - 내가 좋아하는 선생님
            path: '/mytextbook/teacher',
            component: () => import('./views/mytextbook/Teacher.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 내교과서 - 내가 남긴 소통거리
            path: '/mytextbook/communication/:communication_no',
            component: () => import('./views/mytextbook/MyCommunication.vue'),
            props: true,
            meta: {
                auth: true
            }
        },
        {
            // 내교과서 - 내가 남긴 댓글
            path: '/mytextbook/comment',
            component: () => import('./views/mytextbook/MyComment.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 내교과서 - 교과과정
            path: '/mytextbook/course',
            component: () => import('./views/mytextbook/Course.vue'),
            meta: {
                auth: false
            }
        },
        {
            // 참여하기 - 메인
            path: '/mycontent/main',
            component: () => import('./views/mycontent/Main.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 참여하기 - 소통 게시판
            path: '/mycontent/board',
            component: () => import('./views/mycontent/Board.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 참여하기 - 소통 게시판 보기
            path: '/mycontent/board/view/:communication_no',
            component: () => import('./views/mycontent/ViewBoard.vue'),
            props: true,
            meta: {
                auth: true
            }
        },
        {
            // 참여하기 - 소통 게시판 글쓰기
            path: '/mycontent/board/write',
            component: () => import('./views/mycontent/WriteBoard.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 참여하기 - 인기 내가 만든 교과서
            path: '/mycontent/best',
            component: () => import('./views/mycontent/BestContent.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 참여하기 - 내가 참여한 컨텐츠
            path: '/mycontent/mycontent',
            component: () => import('./views/mycontent/MyContent.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 참여하기 - 내 컨텐츠 만들기
            path: '/mycontent/register',
            component: () => import('./views/mycontent/RegisterContent.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 참여하기 - 컨텐츠 제작 시 안내 및 주의사항
            path: '/mycontent/guidance',
            component: () => import('./views/mycontent/Guidance.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 참여하기 - 추천해주세요
            path: '/mycontent/recommended',
            component: () => import('./views/mycontent/RecommendedContent.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 참여하기 - 추천해주세요
            path: '/mypage/push',
            component: () => import('./views/mypage/Push.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 참여하기 - 추천해주세요
            path: '/mypage/push_detail',
            component: () => import('./views/mypage/PushDetail.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 참여하기 - 추천해주세요
            path: '/mypage/point_use_history',
            component: () => import('./views/mypage/PointUseHistory.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 게시판 보기
            name: 'post_view',
            path: '/community/board/view',
            component: () => import('./views/community/ViewPost.vue'),
            props: true,
        },
        {
            // 참여하기 - 추천해주세요
            path: '/community',
            component: () => import('./views/community/Index.vue'),
            meta: {
                auth: true
            },
            children: [
                {
                    path: 'self_tb',
                    component: () => import('./views/community/SelfMade.vue'),
                },
                {
                    path: 'playlist',
                    component: () => import('./views/community/PlayList'),
                },
                {
                    name: 'playlist_info',
                    path: 'playlist_info',
                    component: () => import('./views/community/PlayListInfo.vue'),
                    props: true,
                },
                {
                    path: 'board',
                    component: () => import('./views/community/Board.vue'),
                },
                {
                    // name: 'board_detail',
                    path: 'board_detail',
                    component: () => import('./views/community/BoardDetail.vue'),
                    props: (route) => ({ query: route.query.boardId }),
                },
                {
                    path: 'challenge',
                    component: () => import('./views/community/Challenge.vue'),
                },
                {
                    // name: 'challenge_participate_detail',
                    path: 'challenge_participate_detail',
                    component: () => import('./views/community/ChallengeParticipateDetail.vue'),
                    props: (route) => ({ query: route.query.challengeId }),
                },
                {
                    name: 'challenge_participate_user_detail',
                    path: 'challenge_participate_user_detail',
                    component: () => import('./views/community/ChallengeParticipateUserDetail.vue'),
                    props: true,
                },
            ]
        },
        {
            // 참여하기 - 추천해주세요
            name: 'board_write',
            path: '/community/board_write',
            component: () => import('./views/community/BoardWrite.vue'),
            props:true,
            meta: {
                auth: true
            }
        },
        {
            // challenge - 도전하기
            name: 'participate_challenge',
            path: '/community/challenge_participate/:challengeId',
            component: () => import('./views/community/ChallengeParticipate.vue'),
            props:true,
        },
        {
            // challenge - 작성하기 갱신하기
            name: 'make_challenge',
            path: '/community/make_challenge',
            component: () => import('./views/community/ChallengeMake.vue'),
            props:true,
            meta: {
                auth: true
            }
        },
        {
            // 교육과정
            path: '/curriculum',
            component: () => import('./views/curriculum/Curriculum.vue'),
            meta: {
                auth: true
            },
        },
        {
            // 듣는 선생님
            path: '/listen',
            component: () => import('./views/listen/Teacher.vue'),
            meta: {
                auth: true
            },
            children: [
                {
                    path: 'mission',
                    component: () => import('./views/listen/Mission.vue'),
                },
                {
                    path: 'praise_stamp',
                    component: () => import('./views/listen/PraiseStamp.vue'),
                },
                {
                    path: 'my_listen_note',
                    component: () => import('./views/listen/ListenNote.vue'),
                },
                {
                    path: 'talk_teacher',
                    component: () => import('./views/listen/Talk.vue'),
                },
                {
                    path: 'listen_note_detail',
                    component: () => import('./views/listen/NoteDetail.vue'),
                },
            ]
        },
        {
            // 듣는 선생님
            name: 'question_register',
            path: '/listen/question_register',
            component: () => import('./views/listen/QuestionRegister.vue'),
            meta: {
                auth: true
            }
        },
        {
            // 듣는 선생님 - 질문상세
            name: 'question_detail',
            path: '/listen/question_detail',
            component: () => import('./views/listen/QuestionDetail.vue'),
            meta: {
                auth: true
            }
        },
        { path: "*", redirect: "/home" }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.meta.auth || to.meta.auth === undefined) {
        if (Vue.$cookies.get("accessToken")) {
            if (["/home"].includes(from.path) &&
              (to.path === "/login" || to.path === "/Intro" || to.path === "/"))
                next(from.path);
            else
                next();
        }
        else{
            let ref={
                $router:router
            };
            alert.alertLogin(ref);
        }
    } else {
          next();
    }
  });
export default router;